import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getAuthSnapshot } from '@/context/auth/deriveAuth';

export const Route = createFileRoute('/_authenticated/_member-care')({
  component: Outlet,
  beforeLoad: async () => {
    const { isMemberCare, isOnboarded } = getAuthSnapshot();

    if (!isMemberCare) {
      throw redirect({
        to: '/',
      });
    }

    if (isMemberCare && !isOnboarded) {
      throw redirect({ to: '/onboarding/member-care' });
    }
  },
});
